/* Sandbar Ocean Impact: chart, count-up and share card. No dependencies. */
(function () {
  'use strict';
  if (window.__sbImpact) return; window.__sbImpact = true;
  var NS = 'http://www.w3.org/2000/svg';
  var MON = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function el(t, a, p) { var e = document.createElementNS(NS, t); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
  function fmt(v) { return Math.round(v).toLocaleString('en-GB'); }

  function monotone(P) {
    var k = P.length, d = [], m = [], i;
    for (i = 0; i < k - 1; i++) d.push((P[i + 1][1] - P[i][1]) / (P[i + 1][0] - P[i][0]));
    m[0] = d[0]; m[k - 1] = d[k - 2];
    for (i = 1; i < k - 1; i++) m[i] = (d[i - 1] * d[i] <= 0) ? 0 : (d[i - 1] + d[i]) / 2;
    var s = 'M' + P[0][0].toFixed(1) + ',' + P[0][1].toFixed(1);
    for (i = 0; i < k - 1; i++) {
      var h = (P[i + 1][0] - P[i][0]) / 3;
      s += 'C' + (P[i][0] + h).toFixed(1) + ',' + (P[i][1] + m[i] * h).toFixed(1) + ' ' + (P[i + 1][0] - h).toFixed(1) + ',' + (P[i + 1][1] - m[i + 1] * h).toFixed(1) + ' ' + P[i + 1][0].toFixed(1) + ',' + P[i + 1][1].toFixed(1);
    }
    return s;
  }

  function drawChart(host) {
    var cfg;
    try { cfg = JSON.parse(host.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
    var start = cfg.start.split('-'), y0 = +start[0], m0 = +start[1] - 1;
    var kg = [], run = cfg.opening || 0;
    var months = cfg.monthly.slice(); if (cfg.mtd > 0) months.push(cfg.mtd);
    months.forEach(function (v) { run += v; kg.push(run); });
    var n = kg.length;
    var dt = function (i) { var mm = m0 + i; return { y: y0 + Math.floor(mm / 12), m: mm % 12 }; };
    var svgOld = host.querySelector('svg'); if (svgOld) svgOld.remove();
    var W = host.clientWidth || 1000, H = host.clientHeight || 340, narrow = W < 600;
    var pad = { l: 2, r: 10, t: narrow ? 56 : 60, b: 30 };
    var maxY = kg[n - 1] * 1.05;
    var x = function (i) { return pad.l + (W - pad.l - pad.r) * i / (n - 1); };
    var y = function (v) { return pad.t + (H - pad.t - pad.b) * (1 - v / maxY); };
    var svg = el('svg', { viewBox: '0 0 ' + W + ' ' + H, role: 'img', 'aria-label': 'Cumulative kilograms of ocean plastic removed, rising to ' + fmt(kg[n - 1]) + ' kg in ' + MON[dt(n - 1).m] + ' ' + dt(n - 1).y });
    host.appendChild(svg);
    var defs = el('defs', {}, svg), g = el('linearGradient', { id: 'sbFill' + host.id, x1: 0, y1: 0, x2: 0, y2: 1 }, defs);
    el('stop', { offset: '0%', 'stop-color': '#14213D', 'stop-opacity': .16 }, g);
    el('stop', { offset: '100%', 'stop-color': '#14213D', 'stop-opacity': 0 }, g);
    for (var v = 20000; v < maxY - 3000; v += 20000) {
      el('line', { x1: pad.l, x2: W - pad.r, y1: y(v), y2: y(v), stroke: 'rgba(20,33,61,.08)' }, svg);
      el('text', { x: pad.l, y: y(v) - 7, 'class': 'sb-chart__axis' }, svg).textContent = (v / 1000) + 'k kg';
    }
    el('line', { x1: pad.l, x2: W - pad.r, y1: y(0), y2: y(0), stroke: 'rgba(20,33,61,.3)' }, svg);
    for (var i = 0; i < n; i++) { var d = dt(i); if (d.m === 0) {
      el('line', { x1: x(i), x2: x(i), y1: y(0), y2: y(0) + 5, stroke: 'rgba(20,33,61,.35)' }, svg);
      el('text', { x: x(i), y: H - 6, 'text-anchor': 'middle', 'class': 'sb-chart__axis' }, svg).textContent = d.y;
    } }
    var P = kg.map(function (v, i) { return [x(i), y(v)]; }), line = monotone(P);
    el('path', { d: line + 'L' + x(n - 1) + ',' + y(0) + 'L' + x(0) + ',' + y(0) + 'Z', fill: 'url(#sbFill' + host.id + ')', 'class': 'sb-fade' }, svg);
    var path = el('path', { d: line, fill: 'none', stroke: '#14213D', 'stroke-width': 2.5, 'stroke-linecap': 'round', 'class': 'sb-line' }, svg);
    if (path.getTotalLength) path.style.setProperty('--len', path.getTotalLength());
    var fg = el('g', { 'class': 'sb-fade' }, svg);
    if (cfg.opening) {
      el('circle', { cx: x(0), cy: y(kg[0]), r: 3.5, fill: '#14213D' }, fg);
      el('text', { x: x(0) + 2, y: y(kg[0]) + 24, 'class': 'sb-chart__axis' }, fg).textContent = fmt(cfg.opening) + ' kg carried forward from earlier years';
    }
    (cfg.milestones || [25000, 50000]).forEach(function (mv) {
      var idx = -1; for (var j = 0; j < n; j++) { if (kg[j] >= mv) { idx = j; break; } }
      if (idx < 1) return;
      var cx = x(idx), cy = y(kg[idx]), dd = dt(idx);
      el('line', { x1: cx, x2: cx, y1: cy - 10, y2: cy - 32, stroke: 'rgba(20,33,61,.35)' }, fg);
      el('circle', { cx: cx, cy: cy, r: 4.5, fill: '#F6F1E7', stroke: '#14213D', 'stroke-width': 1.5 }, fg);
      el('text', { x: cx, y: cy - 56, 'text-anchor': 'middle', 'class': 'sb-chart__msn' }, fg).textContent = fmt(mv) + ' kg';
      el('text', { x: cx, y: cy - 39, 'text-anchor': 'middle', 'class': 'sb-chart__ms' }, fg).textContent = MON[dd.m] + ' ' + dd.y;
    });
    var ex = x(n - 1), ey = y(kg[n - 1]);
    el('circle', { cx: ex, cy: ey, r: 6, fill: '#D8402F', 'class': 'sb-pulse' }, fg);
    el('circle', { cx: ex, cy: ey, r: 6, fill: '#D8402F', stroke: '#F6F1E7', 'stroke-width': 2 }, fg);
  }

  function countUp(node) {
    var end = parseInt(node.getAttribute('data-sb-count'), 10); if (!end) return;
    var t0 = null;
    function step(ts) { if (!t0) t0 = ts; var p = Math.min((ts - t0) / 2000, 1), e = 1 - Math.pow(1 - p, 3);
      node.textContent = fmt(end * e); if (p < 1) requestAnimationFrame(step); }
    requestAnimationFrame(step);
  }

  /* Share card: draws a 1080x1920 story image in the browser */
  function shareCard(btn) {
    var kg = btn.getAttribute('data-kg'), name = btn.getAttribute('data-name') || '', tier = btn.getAttribute('data-tier') || '', total = btn.getAttribute('data-total') || '';
    var c = document.createElement('canvas'); c.width = 1080; c.height = 1920;
    var x = c.getContext('2d');
    var ready = (document.fonts && document.fonts.load) ? Promise.all([document.fonts.load('350 400px Fraunces'), document.fonts.load('italic 300 120px Fraunces'), document.fonts.load('500 32px "Instrument Sans"')]) : Promise.resolve();
    ready.catch(function () {}).then(function () {
      x.fillStyle = '#14213D'; x.fillRect(0, 0, 1080, 1920);
      x.strokeStyle = 'rgba(227,213,189,.14)'; x.lineWidth = 2;
      x.beginPath(); x.arc(1080, 840, 500, 0, Math.PI * 2); x.stroke();
      x.beginPath(); x.arc(1080, 840, 350, 0, Math.PI * 2); x.stroke();
      x.fillStyle = '#E3D5BD'; x.font = '500 32px "Instrument Sans", sans-serif';
      if (x.letterSpacing !== undefined) x.letterSpacing = '13px';
      x.fillText('SANDBAR', 90, 150);
      if (x.letterSpacing !== undefined) x.letterSpacing = '8px';
      x.fillStyle = 'rgba(246,241,231,.6)'; x.font = '500 32px "Instrument Sans", sans-serif';
      x.fillText((name ? name.toUpperCase() + ' HAS PULLED' : 'I HAVE PULLED'), 90, 980);
      if (x.letterSpacing !== undefined) x.letterSpacing = '0px';
      x.fillStyle = '#F6F1E7'; x.font = '350 460px Fraunces, Georgia, serif';
      x.fillText(kg, 70, 1380);
      var w = x.measureText(kg).width;
      x.fillStyle = '#E3D5BD'; x.font = 'italic 300 140px Fraunces, Georgia, serif';
      x.fillText('kg', 70 + w + 16, 1380);
      x.fillStyle = '#F6F1E7'; x.font = '350 76px Fraunces, Georgia, serif';
      x.fillText('of plastic out of the sea.', 90, 1520);
      x.fillStyle = '#E3D5BD'; x.font = 'italic 300 76px Fraunces, Georgia, serif';
      x.fillText('By getting dressed.', 90, 1610);
      x.fillStyle = 'rgba(227,213,189,.25)'; x.fillRect(90, 1700, 900, 2);
      x.fillStyle = 'rgba(246,241,231,.55)'; x.font = '500 28px "Instrument Sans", sans-serif';
      x.fillText('TIER', 90, 1760); x.textAlign = 'right'; x.fillText('ALL OF US', 990, 1760);
      x.fillStyle = '#F6F1E7'; x.font = '400 48px Fraunces, Georgia, serif';
      x.textAlign = 'left'; x.fillText(tier, 90, 1825); x.textAlign = 'right'; x.fillText(total + ' kg', 990, 1825);
      x.textAlign = 'left'; x.fillStyle = 'rgba(246,241,231,.55)'; x.font = '400 30px "Instrument Sans", sans-serif';
      x.fillText('wearesandbar.com', 90, 1880);
      x.fillStyle = '#D8402F'; x.beginPath(); x.arc(380, 1870, 9, 0, Math.PI * 2); x.fill();
      c.toBlob(function (blob) {
        var file = new File([blob], 'sandbar-' + kg + 'kg.png', { type: 'image/png' });
        if (navigator.canShare && navigator.canShare({ files: [file] })) {
          navigator.share({ files: [file], title: 'Sandbar', text: kg + ' kg of plastic out of the sea.' }).catch(function () {});
        } else {
          var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = file.name;
          document.body.appendChild(a); a.click(); setTimeout(function () { URL.revokeObjectURL(a.href); a.remove(); }, 1000);
        }
      }, 'image/png');
    });
  }

  function init() {
    var charts = document.querySelectorAll('[data-sb-chart]');
    Array.prototype.forEach.call(charts, function (h) {
      drawChart(h);
      var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { drawChart(h); h.classList.add('is-in'); }, 200); });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { requestAnimationFrame(function () { h.classList.add('is-in'); }); io.disconnect(); } }); }, { threshold: .3 });
        io.observe(h);
      } else { h.classList.add('is-in'); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-sb-count]'), function (n) {
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { countUp(n); io.disconnect(); } }); }, { threshold: .5 });
      io.observe(n);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-sb-share]'), function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); shareCard(b); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
